<template>
    <div id="participant">
        <Topbar v-if="this.$store.state.topbar_actions_visible" @action="fnAction"></Topbar>
        <v-container class="main left">
            <v-layout row wrap class="section-container" id="basic">
                <v-flex xs12 sm6 md3 class="logo" >
                    <img :src="( participant.avatar )? participant.avatar : '/img/avatar.svg'" />
                </v-flex>
                <v-flex xs12 sm6 md9 class="info">
                    <v-container>
                        <v-layout row wrap class="section">
                            <v-flex xs12 class="name">{{ $t( "basic_info" ) }} <div class="edit" @click="editPerson( )">{{ "edit" | i18n }}</div></v-flex>
                            <v-flex xs12 md6>
                                <div class="label">{{ $t( "params.name" ) }}:</div><div class="value">{{ participant.name | checkParam }}</div>
                                <div class="label">{{ $t( "params.surname" ) }}:</div><div class="value">{{ participant.surname | checkParam }}</div>
                                <div class="label"><Phone :phone="$t( 'params.phone' ) + ':'"></Phone></div><div class="value">{{ participant.phone | checkParam }}</div>
                                <div class="label"><Phone :phone="$t( 'params.phone2' ) + ':'"></Phone></div><div class="value">{{ participant.mobile | checkParam }}</div>
                                <div class="label"><Phone :phone="$t( 'campus.phone' ) + ':'"></Phone></div><div class="value" v-if="typeof participant.campus !== 'undefined'">{{ participant.campus.responsable1_phone | checkParam }}</div>
                                <div class="label"><Email :email="$t( 'params.email' ) + ':'"></Email></div><div class="value">{{ participant.email | checkParam }}</div>
                                <div class="label">{{ $t( "params.dni" ) }}:</div><div class="value">{{ participant.dni | checkParam }}</div>
                                <div class="label">{{ $t( "params.birthday" ) }}:</div><div class="value">{{ participant.birthday | checkParam | showDate }}</div>
                                <div class="label">{{ $t( "params.gender" ) }}:</div><div class="value">{{ participant.gender_text | checkParam | i18n }}</div>
                            </v-flex>
                            <v-flex xs12 md6>
                                <div class="label">{{ $t( "params.address" ) }}:</div><div class="value">{{ participant.address | checkParam }}</div>
                                <div class="label">{{ $t( "params.city" ) }}:</div><div class="value">{{ participant.city | checkParam }}</div>
                                <div class="label">{{ $t( "params.cp" ) }}:</div><div class="value">{{ participant.cp | checkParam }}</div>
                                <div class="label">{{ $t( "params.state" ) }}:</div><div class="value">{{ participant.state | checkParam }}</div>
                                <div class="label">{{ $t( "params.country" ) }}:</div><div class="value"><Country v-if="participant.country_id != null" :country="getCountry( participant.country_id )"></Country><div v-else class="value">{{ "" | checkParam }}</div></div>
                                <div class="label">{{ $t( "params.nacionality" ) }}:</div><div class="value"><Country v-if="participant.nacionality != null" :country="getCountry( participant.nacionality )"></Country><div v-else class="value">{{ "" | checkParam }}</div></div>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-flex>
                <v-flex xs12 class="info">
                    <v-container>
                        <v-layout v-if="isNikeCamp" row wrap class="section expanded">
                            <v-flex xs12 class="name">{{ $t( "campus_info" ) }}</v-flex>
                            <v-flex xs12 md6 v-if="typeof participant.campus !== 'undefined'">
                                <div v-if="typeof participant.campus !== 'undefined' && typeof participant.campus.campus !== 'undefined'" v-for="( campus, index ) in participant.campus.campus" :key="index">
                                    <div class="label" v-if="index == 0">{{ $t( "campus.participate" ) }}:</div><div v-else class="label">&nbsp;</div><div class="value delete" @click="fnRemoveCampusWeek(index)">{{ campus | checkParam }}</div>
                                </div>
                                <div class="label">{{ $t( "campus.code" ) }}:</div><div class="value">{{ participant.campus.code | checkParam }}</div>
                                <div class="label">{{ $t( "campus.brothers_discount" ) }}:</div><div class="value" v-if="typeof participant.campus !== 'undefined'">{{ participant.campus.campus_brothers_discount | checkParam }}</div>
                                <div class="label">{{ $t( "campus.bus" ) }}:</div>
                                <div class="value">
                                    <v-select
                                        :items="busOptions"
                                        v-model="participant.campus.campus_bus"
                                        v-on:change="changeBus()"
                                        class="status"
                                    ></v-select>
                                </div>
                                <div class="label">{{ $t( "titles.external" ) }}:</div>
                                <div class="value">
                                    <v-select
                                        :items="pickupOptions"
                                        v-model="participant.campus.campus_pickup"
                                        class="status"
                                        :disabled="true"
                                    ></v-select>
                                </div>
                                <div class="label">{{ $t( "params.travel_number" ) }}:</div><div class="value" v-if="typeof participant.campus !== 'undefined'">{{ participant.campus.campus_transport_number | checkParam }}</div>
                                <div class="label">{{ $t( "params.travel_from" ) }}:</div><div class="value" v-if="typeof participant.campus !== 'undefined'">{{ participant.campus.campus_transport_from | checkParam }}</div>
                                <div class="label">{{ $t( "titles.returnit" ) }}:</div>
                                <div class="value">
                                    <v-select
                                        :items="pickupOptions"
                                        v-model="participant.campus.campus_returnit"
                                        class="status"
                                        :disabled="true"
                                    ></v-select>
                                </div>
                                <!-- <div class="label">{{ $t( "campus.join" ) }}:</Email></div><div class="value">{{ participant.campus.campus_join | checkParam }}</div> -->
                                <div class="label">{{ $t( "campus.lottery_name" ) }}:</div><div class="value" v-if="typeof participant.campus !== 'undefined'">{{ participant.campus.campus_lottery | checkParam }}</div>
                                <div class="label">{{ $t( "campus.lottery_send" ) }}:</div>
                                <div class="value" v-if="typeof participant.campus !== 'undefined'">
                                    <v-select
                                        :items="lotterySendOptions"
                                        v-model="participant.campus.campus_lottery_send"
                                        @change="changeLotterySend( )"
                                        class="status"
                                    ></v-select>
                                </div>
                                <!-- <div class="label">{{ $t( "campus.payment" ) }}:</div><div class="value">{{ participant.campus.campus_payment_type_text | checkParam | i18n }}</div> -->
                                <div class="label">{{ $t( "campus.modality" ) }}:</div>
                                <div class="value" v-if="typeof participant.campus !== 'undefined'">
                                    <v-select
                                        :items="modalityOptions"
                                        :value="participant.campus.campus_modality"
                                        @change="v => changeModality( v )"
                                        item-value="value"
                                        class="status"
                                    ></v-select>
                                </div>
                                <div class="label">{{ $t( "campus.observations" ) }}:</div><div class="value">{{ participant.campus_observations | checkParam }}</div>
                                <div class="label">{{ $t( "campus.responsable" ) }}:</div><div class="value" v-if="typeof participant.campus !== 'undefined'"><router-link class="club" :to="$root.entityUrl('person',participant.campus.responsable1_id)">{{ participant.campus.responsable1_name | checkParam }}</router-link></div>
                            </v-flex>
                            <v-flex xs12 md6 v-if="typeof participant.campus !== 'undefined'">
                                <div class="label">{{ $t( "params.altura" ) }}:</div><div class="value" v-if="typeof participant.campus !== 'undefined'">{{ participant.campus.altura | checkParam }}</div>
                                <div class="label">{{ $t( "campus.goalkeeper" ) }}:</div><div class="value" v-if="typeof participant.campus !== 'undefined'">{{ participant.campus.campus_goalkeeper | checkParam }}</div>
                                <!-- <div class="label">{{ $t( "params.club" ) }}:</div><div class="value" v-if="typeof participant.campus !== 'undefined'">{{ participant.campus.campus_club_name | checkParam }}</div> -->
                                <!-- <div class="label">{{ $t( "campus.shirt_size" ) }}:</div><div class="value" v-if="typeof participant.campus !== 'undefined'">{{ participant.campus.campus_shirt_size | checkParam }}</div> -->
                                <div class="label">{{ $t( "params.swim" ) }}:</div><div class="value" v-if="typeof participant.campus !== 'undefined'">{{ participant.campus.swim | checkParam }}</div>
                                <div class="label">{{ $t( "params.medicamento" ) }}:</div><div v-if="typeof participant.campus !== 'undefined' && participant.campus.b_medicamento" class="value">{{ participant.campus.medicamento | checkParam }}</div><div v-else class="value">{{ "false" | checkParam }}</div>
                                <div class="label" v-if="participant.b_alergy">{{ $t( "params.alergies" ) }}:</div><div v-if="participant.b_alergy" class="value">{{ participant.alergy_text | checkParam }}</div>
                                <div class="label" v-if="!participant.b_alergy">{{ $t( "params.alergies" ) }}:</div><div v-if="!participant.b_alergy" class="value">{{ "false" | checkParam }}</div>
                                <div class="label">{{ $t( "params.other_alergy" ) }}:</div><div class="value">{{ participant.other_allergies | checkParam }}</div>
                                <div class="label">{{ $t( "params.diet" ) }}:</div><div class="value" v-if="participant.diet">{{ $store.state.diet[ participant.diet ].name | checkParam | i18n }}</div>
                            </v-flex>
                        </v-layout>
                        <v-layout v-else-if="isPGA" row wrap class="section expanded">
                            <v-flex xs12 class="name">{{ $t( "campus_info" ) }}</v-flex>
                            <v-flex xs12 md6 v-if="typeof participant.campus !== 'undefined'">
                                <div v-if="typeof participant.campus !== 'undefined'" v-for="( campus, index ) in participant.campus.campus" :key="index">
                                    <div class="label" v-if="index == 0">{{ $t( "campus.participate" ) }}:</div><div v-else class="label">&nbsp;</div><div class="value delete" @click="fnRemoveCampusWeek(index)">{{ campus | checkParam }}</div>
                                </div>
                                <div class="label">{{ $t( "campus.code" ) }}:</div><div class="value">{{ participant.campus.code | checkParam }}</div>
                                <div class="label">{{ $t( "campus.brothers_discount" ) }}:</div><div class="value" v-if="typeof participant.campus !== 'undefined'">{{ participant.campus.campus_brothers_discount | checkParam }}</div>
                                <!-- <div class="label">{{ $t( "campus.bus" ) }}:</div><div class="value">{{ participant.campus.campus_bus | checkParam }}</div> -->
                                <div class="label" v-if="typeof participant.campus !== 'undefined' && $store.state.join_campus[ participant.campus.campus_join_campus ]">{{ $t( "campus.join" ) }}:</Email></div><div class="value" v-if="typeof participant.campus !== 'undefined' && $store.state.join_campus[ participant.campus.campus_join_campus ]">{{ 'campus.' + $store.state.join_campus[ participant.campus.campus_join_campus ].name | i18n | checkParam }}</div>
                                <div class="label">{{ $t( "campus.lottery_name" ) }}:</div><div class="value" v-if="typeof participant.campus !== 'undefined'">{{ participant.campus.campus_lottery | checkParam }}</div>
                                <div class="label">{{ $t( "campus.lottery_send" ) }}:</div>
                                <div class="value" v-if="typeof participant.campus !== 'undefined'">
                                    <v-select
                                        :items="lotterySendOptions"
                                        v-model="participant.campus.campus_lottery_send"
                                        @change="changeLotterySend( )"
                                        class="status"
                                    ></v-select>
                                </div>
                                <!-- <div class="label">{{ $t( "campus.payment" ) }}:</div><div class="value">{{ participant.campus.campus_payment_type_text | checkParam | i18n }}</div> -->
                                <div class="label">{{ $t( "campus.modality" ) }}:</div>
                                <div class="value" v-if="typeof participant.campus !== 'undefined'">
                                    <v-select
                                        :items="modalityOptions"
                                        :value="participant.campus.campus_modality"
                                        @change="v => changeModality( v )"
                                        item-value="value"
                                        class="status"
                                    ></v-select>
                                </div>
                                <div class="label">{{ $t( "campus.observations" ) }}:</div><div class="value">{{ participant.campus_observations | checkParam }}</div>
                                <div class="label">{{ $t( "campus.responsable" ) }}:</div><div class="value" v-if="typeof participant.campus !== 'undefined'"><router-link class="club" :to="$root.entityUrl('person',participant.campus.responsable1_id)">{{ participant.campus.responsable1_name | checkParam }}</router-link></div>
                            </v-flex>
                            <v-flex xs12 md6 v-if="typeof participant.campus !== 'undefined'">
                                <!-- <div class="label">{{ $t( "params.altura" ) }}:</div><div class="value">{{ participant.campus.altura | checkParam }}</div>
                                <div class="label">{{ $t( "campus.goalkeeper" ) }}:</div><div class="value">{{ participant.campus.campus_goalkeeper | checkParam }}</div> -->
                                <div class="label">{{ $t( "params.club" ) }}:</div><div class="value" v-if="typeof participant.campus !== 'undefined'">{{ participant.campus.campus_club_name | checkParam }}</div>
                                <div class="label">{{ $t( "campus.shirt_size" ) }}:</div>
                                <div class="value" v-if="typeof participant.campus !== 'undefined'">
                                    <v-select
                                        :items="shirtSizeOptions"
                                        :value="participant.campus.campus_shirt_size"
                                        @change="v => changeShirtSize( v )"
                                        item-value="value"
                                        class="status"
                                    ></v-select>
                                </div>
                                <div class="label">{{ $t( "params.swim" ) }}:</div><div class="value" v-if="typeof participant.campus !== 'undefined'">{{ participant.campus.swim | checkParam }}</div>
                                <div class="label">{{ $t( "params.medicamento" ) }}:</div><div v-if="typeof participant.campus !== 'undefined' && participant.campus.b_medicamento" class="value">{{ participant.campus.medicamento | checkParam }}</div><div v-else class="value">{{ "false" | checkParam }}</div>
                                <div class="label" v-if="participant.b_alergy">{{ $t( "params.alergies" ) }}:</div><div v-if="participant.b_alergy" class="value">{{ participant.alergy_text | checkParam }}</div>
                                <div class="label" v-if="!participant.b_alergy">{{ $t( "params.alergies" ) }}:</div><div v-if="!participant.b_alergy" class="value">{{ "false" | checkParam }}</div>
                                <div class="label">{{ $t( "params.other_alergy" ) }}:</div><div class="value">{{ participant.other_allergies | checkParam }}</div>
                                <div class="label">{{ $t( "params.diet" ) }}:</div><div class="value" v-if="participant.diet">{{ $store.state.diet[ participant.diet ].name | checkParam | i18n }}</div>
                            </v-flex>
                        </v-layout>
                        <v-layout v-if="isNikeCampBCN || isMundoDeportivo" row wrap class="section expanded">
                            <v-flex xs12 class="name">{{ $t( "campus_info" ) }}</v-flex>
                            <v-flex xs12 md6 v-if="typeof participant.campus !== 'undefined'">
                                <div v-if="typeof participant.campus !== 'undefined' && typeof participant.campus.campus !== 'undefined'" v-for="( campus, index ) in participant.campus.campus" :key="index">
                                    <div class="label" v-if="index == 0">{{ $t( "campus.participate" ) }}:</div><div v-else class="label">&nbsp;</div><div class="value delete" @click="fnRemoveCampusWeek(index)">{{ campus | checkParam }}</div>
                                </div>
                                <div class="label">{{ $t( "campus.code" ) }}:</div><div class="value">{{ participant.campus.code | checkParam }}</div>
                                <div class="label">{{ $t( "campus.brothers_discount" ) }}:</div><div class="value" v-if="typeof participant.campus !== 'undefined'">{{ participant.campus.campus_brothers_discount | checkParam }}</div>
                                <div class="label">{{ $t( "campus.observations" ) }}:</div><div class="value">{{ participant.campus_observations | checkParam }}</div>
                                <div class="label">{{ $t( "campus.responsable" ) }}:</div><div class="value" v-if="typeof participant.campus !== 'undefined'"><router-link class="club" :to="$root.entityUrl('person',participant.campus.responsable1_id)">{{ participant.campus.responsable1_name | checkParam }}</router-link></div>
                                <div class="label" v-if="isNikeCampBCN">{{ $t( "campus.lottery_name" ) }}:</div><div class="value" v-if="typeof participant.campus !== 'undefined'">{{ participant.campus.campus_lottery | checkParam }}</div>
                                <div class="label">{{ $t( "campus.lottery_send" ) }}:</div>
                                <div class="value" v-if="isNikeCampBCN && typeof participant.campus !== 'undefined'">
                                    <v-select
                                        :items="lotterySendOptions"
                                        v-model="participant.campus.campus_lottery_send"
                                        @change="changeLotterySend( )"
                                        class="status"
                                    ></v-select>
                                </div>
                            </v-flex>
                            <v-flex xs12 md6 v-if="typeof participant.campus !== 'undefined'">
                                <div class="label">{{ $t( "params.altura" ) }}:</div><div class="value" v-if="typeof participant.campus !== 'undefined'">{{ participant.campus.altura | checkParam }}</div>
                                <!-- <div class="label">{{ $t( "campus.goalkeeper" ) }}:</div><div class="value" v-if="typeof participant.campus !== 'undefined'">{{ participant.campus.campus_goalkeeper | checkParam }}</div> -->
                                <!-- <div class="label">{{ $t( "params.club" ) }}:</div><div class="value" v-if="typeof participant.campus !== 'undefined'">{{ participant.campus.campus_club_name | checkParam }}</div> -->
                                <!-- <div class="label">{{ $t( "campus.shirt_size" ) }}:</div><div class="value" v-if="typeof participant.campus !== 'undefined'">{{ participant.campus.campus_shirt_size | checkParam }}</div> -->
                                <div class="label">{{ $t( "params.swim" ) }}:</div><div class="value" v-if="typeof participant.campus !== 'undefined'">{{ participant.campus.swim | checkParam }}</div>
                                <div class="label">{{ $t( "params.medicamento" ) }}:</div><div v-if="typeof participant.campus !== 'undefined' && participant.campus.b_medicamento" class="value">{{ participant.campus.medicamento | checkParam }}</div><div v-else class="value">{{ "false" | checkParam }}</div>
                                <div class="label" v-if="participant.b_alergy">{{ $t( "params.alergies" ) }}:</div><div v-if="participant.b_alergy" class="value">{{ participant.alergy_text | checkParam }}</div>
                                <div class="label" v-if="!participant.b_alergy">{{ $t( "params.alergies" ) }}:</div><div v-if="!participant.b_alergy" class="value">{{ "false" | checkParam }}</div>
                                <div class="label">{{ $t( "params.other_alergy" ) }}:</div><div class="value">{{ participant.other_allergies | checkParam }}</div>
                                <!-- <div class="label">{{ $t( "params.diet" ) }}:</div><div class="value" v-if="participant.diet">{{ $store.state.diet[ participant.diet ].name | checkParam | i18n }}</div> -->
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-flex>
                <v-flex xs12 sm12 md12 class="info">
                    <v-container>
                        <Documents :id="id" :event="this.$store.getters['events/getCurrentEvent']().id"></Documents>
                    </v-container>
                </v-flex>
                <v-flex xs12 sm12 md12 class="info">
                    <v-container>
                        <FinancesCard :page="'person'" :data="participant" :bus="bus"></FinancesCard>
                    </v-container>
                </v-flex>
                <v-flex xs12 sm12 md12 class="info" v-if="!isNikeCampBCN">
                    <v-container>
                        <v-layout row wrap class="section">
                            <v-flex xs12 class="name">{{ $t( "titles.campus_rooms" ) }}</v-flex>
                            <v-flex md12 class="player">
                                <v-data-table
                                    :headers="players_headers"
                                    :items="participant.campus.campus_info_rooms.data"
                                    class="elevation-1"
                                    :no-data-text="$t('vtf.datatable.no-data')"
                                    :no-results-text="$t('vtf.datatable.no-data')"
                                    :hide-default-footer="true"
                                    :pagination.sync="pagination"
                                    :rows-per-page-text="''"
                                    hide-actions
                                    item-key="id"
                                    :loading="false"
                                >
                                    <template v-slot:items="props">
                                    <tr>
                                        <td>{{ props.item.name }} </td>
                                        <td>{{ props.item.surname }}</td>
                                        <td>{{ props.item.dni }}</td>
                                    </tr>
                                    </template>
                                    <template v-slot:headers="props">
                                    <tr class="table-header">
                                        <th
                                        role="columnheader"
                                        v-for="header in props.headers"
                                        :key="header.text"
                                        :class="['column']"
                                        >
                                        {{ header.text | i18n }}
                                        </th>
                                    </tr>
                                    </template>
                                </v-data-table>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-flex>
                <v-flex xs12 sm12 md12 class="info">
                    <v-container>
                        <v-layout row wrap class="section">
                            <v-flex xs12 class="name">{{ $t( "titles.campus_training" ) }}</v-flex>
                            <v-flex md12 class="player">
                                <v-data-table
                                    :headers="players_headers"
                                    :items="participant.campus.campus_info_training.data"
                                    class="elevation-1"
                                    :no-data-text="$t('vtf.datatable.no-data')"
                                    :no-results-text="$t('vtf.datatable.no-data')"
                                    :hide-default-footer="true"
                                    :pagination.sync="pagination"
                                    :rows-per-page-text="''"
                                    hide-actions
                                    item-key="id"
                                    :loading="false"
                                >
                                    <template v-slot:items="props">
                                    <tr>
                                        <td>{{ props.item.name }} </td>
                                        <td>{{ props.item.surname }}</td>
                                        <td>{{ props.item.dni }}</td>
                                    </tr>
                                    </template>
                                    <template v-slot:headers="props">
                                    <tr class="table-header">
                                        <th
                                        role="columnheader"
                                        v-for="header in props.headers"
                                        :key="header.text"
                                        :class="['column']"
                                        >
                                        {{ header.text | i18n }}
                                        </th>
                                    </tr>
                                    </template>
                                </v-data-table>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-flex>
                <v-flex xs12 sm12 md12 class="info">
                    <v-container>
                        <v-layout row wrap class="section">
                            <v-flex md12>
                                <v-data-table class="dataTable" id="travels" :headers="tableHeaders" :items="Object.values(travels)" :no-data-text="''" :no-results-text="''" :hideActions="true">
                                    <template v-slot:items="props">
                                        <tr style="height: 50px;">
                                            <td>{{ props.item.type | travelType }}
                                            <td>{{ transport_modes[props.item.transport_mode] }}</td>
                                            <td>{{ props.item.transport_number }}</td>
                                            <td>{{ props.item.transport_company  }}</td>
                                            <!-- <td v-if="props.item.type == '1'">{{ props.item.destination.date }}</td>
                                            <td v-else>{{ props.item.origin.date }}</td>
                                            <td v-if="props.item.type == '1'">{{ props.item.destination.hour }}</td>
                                            <td v-else>{{ props.item.origin.hour }}</td> -->
                                            <td v-if="typeof props.item.origin !== 'undefined' && props.item.origin.entity_type!= '0'">{{ getLocationTransfer(props.item.origin.entity_type, props.item.origin.entity_id).name }}</td>
                                            <td v-else>{{props.item.origin.city}}</td>
                                            
                                            <td>{{ props.item.origin.date }}</td>
                                            <td>{{ props.item.origin.hour }}</td>
                                            <td>{{ props.item.destination.date }}</td>
                                            <td>{{ props.item.destination.hour }}</td>

                                            
                                            <td v-if="typeof props.item.destination !== 'undefined' && props.item.destination.entity_type!= '0'">{{ getLocationTransfer(props.item.destination.entity_type, props.item.destination.entity_id).name }}</td>
                                            <td v-else>{{props.item.destination.city}}</td>
                                            <td>{{ props.item.pax }}</td>
                                            <td v-if="props.item.cost != null">{{ props.item.cost }}€</td>
                                            <td v-else>-</td>
                                            <td>{{ props.item.observations }}</td>
                                            <td style="text-align: center; width: 100px;">                                            
                                                <v-icon @click="editTravel(props.item)">edit</v-icon>
                                                <v-icon @click="removeTravel(props.item)">delete</v-icon>
                                            </td>
                                        </tr>
                                    </template>
                                    <template v-slot:headers="props">
                                        <tr class="table-header">
                                            <th
                                            role="columnheader"
                                            v-for="header in props.headers"
                                            :key="header.text"
                                            :class="['column']"
                                            >
                                            {{ header.text | i18n }}
                                            </th>
                                        </tr>
                                    </template>
                                </v-data-table>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-flex>
            </v-layout>
            <v-layout row wrap class="section-container" id="basic">
                <v-flex xs12 sm12 md12 class="info">
                    <v-container>
                        <v-layout row wrap class="section">
                            <LastUpdate :data="participant.user_modify"></LastUpdate>
                        </v-layout>
                    </v-container>
                </v-flex>
            </v-layout>
            <v-layout row wrap class="section-container" id="notes">
                <NoteList :notes="participant.notes" :page="'person'" :id="id" @create_note="createNote"></NoteList>
            </v-layout>
        </v-container>
        <ContactRelationsList :contacts_rel="participant.current_roles" class="contact right"></ContactRelationsList>
    </div>
</template>

<script>
    import Vue from "vue";
import i18n from '@/i18n'
import NoteList from '@/components/ui/NoteList'
import TeamCard from '@/components/ui/cards/mini/Team'
import Topbar from '@/components/ui/Topbar'
import FinancesCard from '@/components/ui/FinancesCard'
import Documents from '@/components/ui/Documents'

import ContactRelationsList from '@/components/ui/ContactRelationsList'

import Phone from '@/components/ui/labels/Phone'
import Email from '@/components/ui/labels/Email'
import Country from '@/components/ui/labels/Country'
import LastUpdate from '@/components/ui/LastUpdate'

export default {
  name: 'CardParticipant',
  components: {
    NoteList,
    TeamCard,
    Topbar,
    Phone,
    Email,
    Country,
    ContactRelationsList,
    LastUpdate,
    FinancesCard,
    Documents
  },
  props: {},
  data () {
    return {
      id: this.$route.params.id,
      current_roles: [],
      lotterySendOptions: [ { text: i18n.t('bool.si'), value: '1' }, { text: i18n.t('bool.no'), value: '0' } ],
      busOptions: [ { text: i18n.t('campus.bus_type.go'), value: '1' }, { text: i18n.t('campus.bus_type.back'), value: '2' }, { text: i18n.t('campus.bus_type.both'), value: '3' }, { text: i18n.t('bool.no'), value: '0' } ],
      pickupOptions: [ { text: i18n.t('campus.pickup.bcncenter'), value: '1' }, { text: i18n.t('campus.pickup.bcnsants'), value: '2' }, { text: i18n.t('campus.pickup.bcnairport'), value: '3' }, { text: i18n.t('bool.no'), value: '0' } ],
      modalityOptions: [ { text: i18n.t('campus.intern'), value: 1 }, { text: i18n.t('campus.extern'), value: 2 } ],
      bus: new Vue(),
      tableHeaders: [
            { text: i18n.t('params.type'), value: 'type' },
            { text: i18n.t('params.transport_mode'), value: 'transport_mode', sortable: true },
            { text: i18n.t('params.transport_number'), value: 'transport_number', sortable: false },
            { text: i18n.t('params.transport_company'), value: 'transport_company', sortable: true },
            { text: i18n.t('params.origin_place'), value: 'origin.entity_id', sortable: true },
            { text: i18n.t('params.origin_date'), value: 'origin.date', sortable: true },
            { text: i18n.t('params.origin_hour'), value: 'origin.hour', sortable: true },
            { text: i18n.t('params.destination_date'), value: 'origin.date', sortable: true },
            { text: i18n.t('params.destination_hour'), value: 'origin.hour', sortable: true },
            { text: i18n.t('params.destination'), value: 'destination.entity_id', sortable: true },
            { text: i18n.t('params.n_pax'), value: 'pax', sortable: true },
            { text: i18n.t('params.cost'), value: 'cost', sortable: true },
            { text: i18n.t('params.observations'), value: 'observations', sortable: false },
            { text: i18n.t('params.actions'), sortable: false }
        ],
        players_headers: [
            { text: 'params.name', value: 'name', sortable: true },
            { text: 'params.surname', value: 'surname', sortable: true },
            { text: 'params.dni', value: 'dni', sortable: true },
        ],
    }
  },
  computed: {
    participant () {
      var oPerson = JSON.parse(JSON.stringify(this.$store.getters['persons/get_by_id'](this.$route.params.id))) // { ...this.$store.getters["persons/get_by_id"](this.$route.params.id) };
      if (!oPerson) oPerson = {}

      oPerson.gender_text = oPerson.gender != null ? 'gender.' + oPerson.gender : null
      oPerson.notes = ObjectToArray(oPerson.notes)
      //   var aAlergies = this.$store.getters["persons/getAlergies"]();

      oPerson.notes = ObjectToArray(oPerson.notes)
      oPerson.notes.sort(function (n1, n2) {
        if (moment(n1.last_update).valueOf() < moment(n2.last_update).valueOf()) { return 1 }
        return -1
      })

      //   if (typeof oPerson.current_roles === "undefined")
      //     oPerson.current_roles = [];
      //   else {
      //     oPerson.current_roles.forEach(role => {
      //       role.visible = true;
      //     });
      //   }

      this.current_roles = oPerson.current_roles
      var bFound = false
      if (typeof oPerson.current_roles !== 'undefined') {
        var self = this
        oPerson.current_roles.forEach(role => {
          if (!bFound && role.contact_type_id == 'aXFZalgzRzFTeTVHZDVyWWIrei9uZz09' && role.event.id == this.$store.getters[ 'events/getCurrentEvent']().id) {
            var sCampusName = role.campus_name
            if (self.$store.getters['events/getCurrentEvent']().type_id == 12) {
              sCampusName = sCampusName.split('.')
              sCampusName = sCampusName[0] + '.' + sCampusName[1] + '.' + sCampusName[2] + '_' + sCampusName[3]
            }
            oPerson.campus = Object.assign({},role)
            oPerson.campus.campus = [ i18n.t(sCampusName) + ' ' + moment(role.campus_start_date).format('DD/MM/YYYY') + ' - ' + moment(role.campus_end_date).format('DD/MM/YYYY') ]
            oPerson.campus.campusIDs = [ role.campus_id ]
            oPerson.campus.campus_brothers_discount = oPerson.campus.campus_brothers_discount == '1'
            //oPerson.campus.campus_bus = oPerson.campus.campus_bus == '1'
            oPerson.campus.campus_join = oPerson.campus.campus_join == '1'
            oPerson.campus.campus_lottery = oPerson.campus.campus_lottery == '1'
            oPerson.campus.campus_goalkeeper = oPerson.campus.campus_goalkeeper == '1'
            oPerson.campus.campus_payment_type_text = oPerson.campus.campus_payment_type == '1' ? 'campus.fullpayment' : 'campus.installment_payment'
            oPerson.campus.campus_modality_text = oPerson.campus.campus_modality == '1' ? 'campus.intern' : 'campus.extern'
            oPerson.campus.campus_modality = parseInt(oPerson.campus.campus_modality)

            if( role.campus_info_rooms ){
                oPerson.campus.campus_info_rooms = JSON.parse(role.campus_info_rooms)
            } else {
                oPerson.campus.campus_info_rooms = []
            }

            if( role.campus_info_training ){
                oPerson.campus.campus_info_training = JSON.parse(role.campus_info_training)
            } else {
                oPerson.campus.campus_info_training = []
            }

            bFound = true
          } else if (role.contact_type_id == 'aXFZalgzRzFTeTVHZDVyWWIrei9uZz09' && role.event.id == this.$store.getters[ 'events/getCurrentEvent']().id) {
              //console.log(JSON.parse(JSON.stringify(role)))
            var sCampusName = role.campus_name
            if (self.$store.getters['events/getCurrentEvent']().type_id == 12) {
              sCampusName = sCampusName.split('.')
              sCampusName = sCampusName[0] + '.' + sCampusName[1] + '.' + sCampusName[2] + '_' + sCampusName[3]
            }
            //console.log(i18n.t(sCampusName) + ' ' + moment(role.campus_start_date).format('DD/MM/YYYY') + ' - ' + moment(role.campus_end_date).format('DD/MM/YYYY'))
            oPerson.campus.campus.push(i18n.t(sCampusName) + ' ' + moment(role.campus_start_date).format('DD/MM/YYYY') + ' - ' + moment(role.campus_end_date).format('DD/MM/YYYY'))
            oPerson.campus.campusIDs.push(role.campus_id)
          }
        })
      } else {
        oPerson.campus = {}
      }

      oPerson.alergy_text = ''
      if (oPerson.b_alergy) {
        var alergies = this.$store.state.persons.alergies
        if (oPerson.alergy != null) {
          if (typeof oPerson.alergy === 'object') oPerson.alergy = oPerson.alergy.toString()
          if (typeof oPerson.alergy !== 'undefined' && oPerson.alergy != null) {
            oPerson.alergy.split(',').forEach(alergy => {
              if (typeof alergies[ alergy ] !== 'undefined') {
                oPerson.alergy_text += (oPerson.alergy_text != '' ? ',' : '')
                oPerson.alergy_text += i18n.t(alergies[ alergy ].name)
              }
            })
          }
        } else {
          oPerson.alergy_text += ''
        }
      }
      // this.person = oPerson

      return Object.assign({},oPerson)
    },

    shirtSizeOptions () {
      var shirts = this.$store.state.shirt_size
      var sizes = []
      for (var i in shirts) {
        sizes.push({
          text: i18n.t('campus.' + shirts[i].name),
          value: shirts[i].id
        })
      }

      return sizes
    },

    isNikeCamp() {
        var event = this.$route.params.event
        return event.match(/(nikecamp|miccamp)\d{2}/gi)
    },

    isNikeCampBCN() {
        var event = this.$route.params.event
        return event.match(/(nikecampbcn|miccampbcn)\d{2}/gi)
    },

    isMundoDeportivo() {
        var event = this.$route.params.event
        return event.match(/(mundodeportivofutcamp)\d{2}/gi)
    },

    isPGA() {
        var event = this.$route.params.event
        return event.match(/(pga)\d{2}/gi) || event.match(/(paugasolacademy)\d{2}/gi)
    },

    currentEvent() {
        return this.$store.getters[ 'events/getCurrentEvent' ]();
      },

    travels() {
        var list = this.$store.getters['travels/getList']();
        var findArrive = Object.values(list).find(obj => {
            return obj.type == 1;
        });
        findArrive ? this.arrive = findArrive : this.arrive = '';

        var findDesparture = Object.values(list).find(obj => {
            return obj.type == 3;
        });
        findDesparture ? this.departure = findDesparture : this.departure = '';

        return list;
    },
    locationsTransfer() {
        return this.$store.getters['travels/getLocations']();
    },

    transport_modes() {
        var oOptions = this.$store.getters.getTransportMode();
        var aResult = []
        for( var k in oOptions ){
            aResult[oOptions[k].id] = i18n.t(  "travels.transport_mode." + oOptions[k].name );
        }
        return aResult
    },
  },
  created () {
    this.loadDataPage()
  },
  methods: {
    loadDataPage() {
        this.$overlay.loading()

        this.$store.commit('setTopbarActionsVisible', true)
        this.$store.commit('setMenuVisible', true)

        var id = this.$route.params.id
        var self = this
        self.$store.dispatch('travels/loadTravelInfo').then(function(){
            self.$store.dispatch('travels/loadParticipantTravels',{participant_id : id, event_id: self.currentEvent.id}).then(function(){
                self.$store.dispatch('persons/load_by_id', { id: id }).then(function () {
                    self.$overlay.hide()
                })
            })
        })
    },

    createNote () {
      this.$card.note({
        current_page: 'person',
        current_id: this.$route.params.id
      })
    },

    createContactRelationship () {
      this.$card.contactrel({
        current_page: 'person',
        current_id: this.$route.params.id
      })
    },

    getCountry (id) {
      if (id) {
        return { ...this.$store.getters.getCountryByID(id) }
      }
      return false
    },

    fnAction (emit) {
      if (typeof emit.action === 'undefined' || emit.action == null) return
      switch (emit.action) {
        case 'remove':
          this.fnRemove(emit.params)
          break
        case 'create_note':
          this.createNote(emit.params)
          break
        case 'create_relationship':
          this.createContactRelationship(emit.params)
          break
        case 'rel_club_event':
          this.fnRelClubEvent(emit.params)
          break
        case 'destroy':
          this.fnDestroy(emit.params)
          break
        case 'preview_teamzone':
          this.$root.fnGoToTeamZones(3)
          break
        case 'assign_week':
            this.fnAssignToWeek(emit.params)
            break
      }
    },

    fnRemove () {
      var self = this
      var event = this.$store.getters['events/getCurrentEvent']()

      this.$popup.confirm(
        {
          message: i18n.t('participants.remove_message'),
          btnSuccess: i18n.t('accept'),
          btnError: i18n.t('cancel')
        },
        function () {
          self.$store.dispatch('persons/remove_participant', { id: self.id, event_id: event.id }).then(function () {
            var event = self.$store.getters.isEventSelected
              ? self.$store.getters['events/getCurrentEvent']()
              : false
            var page = event ? 'event_' : ''
            page = page + 'participants'

            self.$router.push({
              name: page,
              params: {
                event: self.$root
                  .formatEventUrl(event.name, event.edition)
                  .replace('/event/', '')
              }
            })
          })
        }
      )
    },

    fnAssignToWeek() {
        var self = this
        var event = this.$store.getters['events/getCurrentEvent']()

        this.$card.assignParticipantCampus({
            event_id: event.id,
            callBack: function(plug, params, store) {
                if( event.id == plug.params.event_id ){
                    self.$store.dispatch("persons/assignParticipantCampus", { participant_id: self.participant.id,event_id: plug.params.event_id, week_id: plug.params.week_id, contact_type_id: plug.params.contact_type_id}).then( response => {
                        self.$popup.alert({
                            message: i18n.t("participants.assign_participant_week_complete"),
                            btnSuccess: i18n.t("accept")
                        });
                        self.$card.close();
                        self.loadDataPage();
                    })
                    /*.catch( error => {
                        self.$popup.alert({
                            message: i18n.t("errors." + e),
                            btnSuccess: i18n.t("accept")
                        });
                        self.$card.close();
                    })*/
                }
                else {
                    self.$store.dispatch("persons/assignParticipantCampusNewEvent", { participant_id: self.participant.id,event_id: event.id, new_event_id: plug.params.event_id, week_id: plug.params.week_id, contact_type_id: plug.params.contact_type_id}).then( response => {
                        self.$popup.alert({
                            message: i18n.t("participants.assign_participant_week_complete"),
                            btnSuccess: i18n.t("accept")
                        });
                        self.$card.close();
                        self.loadDataPage();
                    })
                    /*.catch( error => {
                        self.$popup.alert({
                            message: i18n.t("errors." + e),
                            btnSuccess: i18n.t("accept")
                        });
                        self.$card.close();
                    })*/
                }
            }
        });
    },

    fnRemoveCampusWeek(index){
        var self = this
        this.$popup.confirm({
            message: i18n.t('participants.remove_campus_week', { week: this.participant.campus.campus[index], event: this.$root.formatEventName(this.currentEvent.name, this.currentEvent.edition)}),
            btnSuccess: i18n.t('accept'),
            btnError: i18n.t('cancel')
        }, function () {
            self.$store.dispatch("persons/removeParticipantCampus", { participant_id: self.participant.id,event_id: self.currentEvent.id, role_id: self.participant.current_roles[index].id}).then( response => {
              self.$popup.alert({
                message: i18n.t("participants.remove_participant_week_complete"),
                btnSuccess: i18n.t("accept")
              });
              self.loadDataPage();
          })
          /*.catch( error => {
              self.$popup.alert({
                message: i18n.t("errors." + e),
                btnSuccess: i18n.t("accept")
              });
              self.$card.close();
          })*/
        },
        function () {

        })
    },

    getPosition (position) {
      var pos = this.$store.getters['persons/getPosition'](position)
      if (pos && typeof pos.name !== 'undefined') {
        return pos.name
      }

      return null
    },

    editPerson () {
      var event = (this.$store.getters.isEventSelected) ? this.$store.getters[ 'events/getCurrentEvent' ]() : false
      event = (event) ? this.$root.formatEventUrl(event.name, event.edition).replace('/event/', '') : null

      this.$router.push({ name: 'persons_edit', params: { event: event, id: this.$route.params.id } })
    },

    editRole (key) {
      var event = this.$store.getters.isEventSelected
        ? this.$store.getters['events/getCurrentEvent']()
        : false
      event = event
        ? this.$root
          .formatEventUrl(event.name, event.edition)
          .replace('/event/', '')
        : null
      var page = event ? 'event_' : ''
      page = page + 'persons_role_edit'
      var role = this.person.current_roles[key]

      var type = ''
      switch (parseInt(role.contact_type_id)) {
        case 107:
          type = 'player'
          break
        case 5:
        case 108:
        case 6:
          type = 'manager'
          break
        case 1:
        case 2:
          type = 'staff'

        case 111:
          type = 'team'
          break
      }

      this.$router.push({
        name: page,
        params: {
          event: event,
          id: this.person.id,
          role_id: role.id,
          type: type
        }
      })
    },

    changeLotterySend () {
      var oParams = {
        id: this.participant.id,
        event_id: this.$store.getters['events/getCurrentEvent']().id,
        lottery_send: this.participant.campus.campus_lottery_send
      }
      var self = this

      this.$popup.confirm({
        message: i18n.t('participants.change_lottery_send.' + this.participant.campus.campus_lottery_send),
        btnSuccess: i18n.t('accept'),
        btnError: i18n.t('cancel')
      }, function () {
        self.$store.dispatch('persons/changeLotterySend', oParams).then(function () {

        })
      },
      function () {

      })
    },

    changeBus () {
      var oParams = {
        id: this.participant.id,
        event_id: this.$store.getters['events/getCurrentEvent']().id,
        bus: this.participant.campus.campus_bus
      }
      var self = this

      this.$popup.confirm({
        message: i18n.t('participants.change_bus_send.' + this.participant.campus.campus_bus),
        btnSuccess: i18n.t('accept'),
        btnError: i18n.t('cancel')
      }, function () {
        self.$store.dispatch('persons/changeBus', oParams).then(function () {
            self.bus.$emit('reload')
        })
      },
      function () {
          //self.participant.campus.campus_bus = self.participant.campus.campus_bus == '1' ? '2' : '1'
      })
    },

    changeModality (modality) {
      var oParams = {
        id: this.participant.id,
        event_id: this.$store.getters['events/getCurrentEvent']().id,
        modality: modality
      }
      var self = this

      this.$popup.confirm({
        message: i18n.t('participants.change_modality.' + modality),
        btnSuccess: i18n.t('accept'),
        btnError: i18n.t('cancel')
      }, function () {
        self.$store.dispatch('persons/changeModality', oParams).then(function () {

        })
      },
      function () {

      })
    },

    changeShirtSize (shirt) {
      var oParams = {
        id: this.participant.id,
        event_id: this.$store.getters['events/getCurrentEvent']().id,
        shirt_size: shirt
      }
      var self = this

      this.$popup.confirm({
        message: i18n.t('participants.change_shirt.' + this.$store.state.shirt_size[ shirt ].name),
        btnSuccess: i18n.t('accept'),
        btnError: i18n.t('cancel')
      }, function () {
        self.$store.dispatch('persons/changeShirtSize', oParams).then(function () {

        })
      },
      function () {

      })
    },

    fnDestroy () {
      this.$destroy()
    },

    addTravel(){
        var event_id = ( this.$store.getters.isEventSelected ) ? this.$store.getters[ 'events/getCurrentEvent' ]().id : false;
        this.$router.push( { name: ( event_id ? 'event_travels_add' : 'travels_add' ), params: { entity_type: 2, entity_id: this.$route.params.id } })
    },

    editTravel(item){
        var event_id = ( this.$store.getters.isEventSelected ) ? this.$store.getters[ 'events/getCurrentEvent' ]().id : false;
        this.$router.push( {name: ( event_id ? 'event_travels_edit' : 'travels_edit' ), params: { id: item.id, event: event_id } } )
    },

    removeTravel(item){
        var self = this
        var event_id = ( this.$store.getters.isEventSelected ) ? this.$store.getters[ 'events/getCurrentEvent' ]().id : false;
        this.$popup.confirm(
            {
            message: i18n.t("travels.remove_message"),
            btnSuccess: i18n.t("accept"),
            btnError: i18n.t("cancel")
            },
            function() {
                self.$store.dispatch("travels/remove", item.id).then(function() {
                    var id = self.$route.params.id;
                    self.$store.dispatch('travels/loadTeamTravels',{team_id : id}).then(function(){})
                });
            }
        );
    },

    getLocationTransfer( entity_type, entity_id ){
        if( parseInt(entity_type) == 4 ){
            return this.$store.getters['hotels/get_by_id']( entity_id )
        } else if( parseInt(entity_type) == 5 ){
            return this.$store.getters['facilitys/get_by_id']( entity_id )
        } else if( parseInt(entity_type) == 11 ){
            var locations = this.$store.getters['travels/getLocations']()
            return locations[entity_id] ? locations[entity_id] : ""
        }
    },
  },
  filters: {
      travelType( t ){
            return i18n.t('travels.travel_type_' + t)
        }
  }
}
</script>

<style lang="scss" scoped>
#participant {
  width: 100%;
  display: inline-block;

  .container {
    width: calc(100% - 350px);
    padding: 0px;
    max-width: 100%;

    &.main {
      overflow-y: auto;
      height: calc(100vh - 110px);
    }

    .section-container {
      padding: 20px;

      &#basic {
        background-color: #fff;
        @include box-shadow($h: 0px, $v: 3px, $b: 8px, $s: 0px, $c: #00000011);
      }
      &#notes {
        background-color: $complem-color-light;
      }
      &#teams {
        background-color: #fff;
        @include box-shadow($h: 0px, $v: -3px, $b: 8px, $s: 0px, $c: #00000011);
      }
    }
  }

  .v-datatable thead .column {
    text-align: left;
  }

  .contact {
    width: 20%;
    width: 350px;
    padding: 20px;
  }

  .logo {
    width: 150px;
    height: 150px;
    border-radius: 50%;

    img {
      object-fit: contain;
      object-position: center;
      height: 100%;
      width: auto;
      margin: 0 auto;
      display: block;
      margin-top: 50px;
      opacity: 0.5;
    }
  }
  .info {
    .container {
      margin: 0;
      padding: 0 20px;
      padding-left: 40px;
      width: 100%;

      .section {
        margin-bottom: 25px;

        .name {
          font-weight: lighter;
          font-size: 24px;
          @include font-size(14px);
          border-bottom: 1px solid #ddd;
          margin: 10px 0 20px 0;
          color: $main-color;
          text-transform: uppercase;
          margin-bottom: 20px;
          border-bottom: 2px solid $complem-color-dark;
          color: $complem-color-dark;
          position: relative;
        }

        .label {
          font-family: $text-light;
          @include font-size(14px);
          width: 40%;
        //   min-width: 200px;
          float: left;
          line-height: 20px;
        }

        .value {
          font-family: $text;
          font-weight: lighter;
          @include font-size(14px);
          width: 60%;
          float: left;
          margin-bottom: 10px;
          position: relative;

          &.delete::after {
                content: " ";
                background: url(/img/delete_alert.svg);
                background-size: 20px;
                background-repeat: no-repeat;
                width: 20px;
                height: 20px;
                position: absolute;
                margin-left: 5px;
                cursor: pointer;
          }
        }

        .edit {
            background-image: url(/img/edit-b.svg);
            background-size: 15px;
            background-repeat: no-repeat;
            background-position: left center;
            position: absolute;
            right: 0;
            top: -5px;
            padding-left: 20px;
            text-transform: none;
            font-weight: bold;
            cursor: pointer;
        }

        &.expanded {
            .label {
                width: 30%;
            }
            .value {
                width: 70%;
            }
        }
      }
    }

    &.role .name {
      position: relative;
      width: fit-content;
      cursor: pointer;

      &::after {
        content: "";
        width: 30px;
        height: 15px;
        background: url(/img/down.svg);
        background-repeat: no-repeat;
        background-size: 15px;
        background-position: center right;
        position: absolute;
      }
    }
  }

    .v-input.status.v-text-field.v-select.v-input--is-label-active.v-input--is-dirty.theme--light {
        width: 80%;
    }
}
</style>
